import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useClipboard from 'react-use-clipboard';

import {
  ButtonArrowState,
  FontFamily,
  TertiaryButton,
} from '@huggg/react-components';

import styles from './types.module.scss';

const Url = (props) => {
  const { data, value } = props;
  const [isCopied, setIsCopied] = useClipboard(value, { successDuration: 400 });

  const onClick = useCallback(() => {
    if (value) {
      setIsCopied(true);
    }
  }, [setIsCopied, value]);

  return (
    <div>
      <a
        rel="noreferrer noopener"
        href={data.value}
        className={styles.voucherButtonLink}
      >
        <TertiaryButton
          className={styles.voucherButton}
          location={data.value}
          onClick={onClick}
          data-test-id="button-visit-external"
          label={data.label}
          arrow={ButtonArrowState.None}
          fontFamily={FontFamily.PoppinsRegular}
        />
      </a>

      <div
        className={classnames(styles.copyText, {
          [styles.copyTextVisible]: isCopied,
        })}
      >
        Copied to clipboard!
      </div>
    </div>
  );
};

Url.propTypes = {
  data: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
};

export default Url;
